<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";
import { addSizeToDataLayer } from "@/functions/analytics";
import DimensionInput from "@/components/UI/DimensionInput.vue";
import ShapeInputFieldsWrapper from "@/components/UI/ShapeInputFieldsWrapper.vue";
import {Props} from "@/components/ShapeType.vue";

const store = useStore();
const { isCutout, action, prefix } = defineProps<Props>();

const dimensions = computed(() => store.getters.getMeasurements( 'isosceles-triangle', isCutout ) );
const dimensionLabel = computed(() => store.getters.dimensionLabel);
const dimensionMaxLabel = computed(() => store.getters.getMaxLabelForDimension);
const isDimensionValid = computed(() => store.getters.isShapeValid( isCutout ) );

const base = computed({
	get: () => dimensions.value.base,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "base",
			value: value,
		});
	},
});

const height = computed({
	get: () => dimensions.value.height,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "height",
			value: value,
		});
	},
});
</script>
<template>
	<shape-input-fields-wrapper>
		<dimension-input
			inputRef="isosceles-triangle-base"
			:id="`${prefix}measurements-isosceles-triangle-base`"
			:name="`${prefix}measurements[dimensions][base]`"
			unit="cm"
			:label="dimensionLabel('width', 'isosceles-triangle')"
			:instructions="isCutout ? '' : dimensionMaxLabel('width')"
			:invalid="!isDimensionValid(`${prefix}isosceles-triangle-base`)"
			:onBlur="() => addSizeToDataLayer('base', +base, 'isosceles-triangle')"
			v-model="base"
		/>

		<dimension-input
			inputRef="isosceles-triangle-height"
			:id="`${prefix}measurements-isosceles-triangle-height`"
			:name="`${prefix}measurements[dimensions][height]`"
			unit="cm"
			:label="dimensionLabel('height', 'isosceles-triangle')"
			:instructions="isCutout ? '' : dimensionMaxLabel('height')"
			:invalid="!isDimensionValid(`${prefix}isosceles-triangle-height`)"
			:onBlur="() => addSizeToDataLayer('height', +height, 'isosceles-triangle')"
			v-model="height"
		/>
	</shape-input-fields-wrapper>
</template>
